import {BLOCK_TYPES, MESSAGE_ROLES} from './config.js'

export const isLastMessageAnError = (messages = []) => {
  const lastMessage = messages.slice(-1)[0]
  return lastMessage.blocks?.slice(-1)?.[0]?.error
}

export const getAssistantErrorMessage = i18n => ({
  role: MESSAGE_ROLES.ASSISTANT,
  blocks: [{type: BLOCK_TYPES.TEXT, content: i18n.t('NET.ERRORS.ASSISTANT_RESPONSE'), error: true}]
})

/**
 * Map chat content to add favorite status to results items
 */
export const mapChatContentWithFavorites = (content = [], favorites = []) => {
  const favoriteAdIds = new Set(favorites.map(ad => ad.id))

  return content.map(message => {
    if (message.role !== MESSAGE_ROLES.ASSISTANT || !message.blocks) return message

    return {
      ...message,
      blocks: message.blocks.map(block => {
        if (block.type === BLOCK_TYPES.AD_CARD) {
          return {...block, isFavorite: favoriteAdIds.has(Number(block.id))}
        }

        if (block.type !== BLOCK_TYPES.RESULTS || !block.response?.items) return block

        return {
          ...block,
          response: {
            ...block.response,
            items: block.response.items.map(ad => ({
              ...ad,
              isFavorite: favoriteAdIds.has(Number(ad.id))
            }))
          }
        }
      })
    }
  })
}
